import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class EnvironmentService {

  public apiURL = JSON.parse(localStorage.getItem('apiURL'));
  public userType = JSON.parse(localStorage.getItem('userType'));
  public compactViewWidth = JSON.parse(localStorage.getItem('compactViewWidth'));
  public oldAppURL = JSON.parse(localStorage.getItem('oldAppURL'));
  public production = JSON.parse(localStorage.getItem('production'));
  public reconnectionTime = JSON.parse(localStorage.getItem('reconnectionTime'));
  public appName = JSON.parse(localStorage.getItem('appName'));
  public tooltipDelay = JSON.parse(localStorage.getItem('tooltipDelay'));

  public settings: any;

  constructor() {
    this.settings = JSON.parse(localStorage.getItem('psSettingsKey')); 
  }

  public getApiURL() {
    return JSON.parse(localStorage.getItem('apiURL'));
  }

  public getUserType() {
    return JSON.parse(localStorage.getItem('userType'));
  }

  public getCompactViewWidth() {
    return JSON.parse(localStorage.getItem('compactViewWidth'));
  }

  public getOldAppURL() {
    return JSON.parse(localStorage.getItem('oldAppURL'));
  }

  public getProduction() {
    return JSON.parse(localStorage.getItem('production'));
  }

  public getReconnectionTime() {
    return JSON.parse(localStorage.getItem('reconnectionTime'));
  }

  public getAppName() {
    return JSON.parse(localStorage.getItem('appName'));
  }

  public getServiceAppName() {
    return JSON.parse(localStorage.getItem('serviceAppUrl'));
  }

  public getTooltipDelay() {
    return JSON.parse(localStorage.getItem('tooltipDelay'));
  }

  public setEnvironment(environment: any) {
    localStorage.setItem('production', JSON.stringify(environment.production));
    localStorage.setItem('apiURL', JSON.stringify(environment.apiURL));
    localStorage.setItem('userType', JSON.stringify(environment.userType));
    localStorage.setItem('oldAppURL', JSON.stringify(environment.oldAppURL));
    localStorage.setItem('menuPosition', JSON.stringify(environment.menuPosition));
    localStorage.setItem('reconnectionTime', JSON.stringify(environment.reconnectionTime));
    localStorage.setItem('compactViewWidth', JSON.stringify(environment.compactViewWidth));
    localStorage.setItem('appName', JSON.stringify(environment.appName));
    localStorage.setItem('tooltipDelay', JSON.stringify(environment.tooltipDelay));

    if (!environment.production) {
      console.log('Srodowisko: ' + JSON.stringify(environment));
    }
  }

}
